import "./MobileYourQuoteHeader.scss"
import React, { useState } from 'react'
import CONSTANTS from "../../../Constants";

const MobileYourQuoteHeader = ({ handleClick }) => {
    return (
        <div className='Op-deteail-header'>
            <i className='back-arrow' onClick={handleClick}></i>
            <li className='header-title-block'>
                {CONSTANTS.SITE_CONFIG.currentBrand === 'P' && <i className='quote-icon'></i>}

                <h4 className='title'>Your quote</h4>

            </li>
        </div>
    )
}
export default MobileYourQuoteHeader;